import Logo from "./Logo";
import { COMPANY } from "../data/whitespaces";

export const Footer = ({ onScrollTo }) => (
  <footer data-testid="footer" className="relative z-10 border-t border-white/10 bg-black/40 px-6 py-14 backdrop-blur-sm md:px-12">
    <div className="mx-auto flex max-w-[1600px] flex-col items-start justify-between gap-8 md:flex-row md:items-center">
      <div>
        <Logo className="h-7 md:h-8" onClick={() => onScrollTo("top")} testId="footer-whitespaces-logo" />
        <p className="mt-4 max-w-xs font-body text-[13px] leading-relaxed text-white/35">
          {COMPANY.tagline}. {COMPANY.heritage}.
        </p>
      </div>
      <div className="flex flex-wrap gap-x-8 gap-y-2">
        {COMPANY.offices.map((o) => (
          <span key={o} className="font-body text-[12px] uppercase tracking-[0.15em] text-white/40">
            {o}
          </span>
        ))}
      </div>
    </div>
    <div className="mx-auto mt-10 flex max-w-[1600px] items-center justify-between border-t border-white/5 pt-6">
      <span className="font-body text-[11px] uppercase tracking-[0.15em] text-white/25">
        © {new Date().getFullYear()} Whitespaces
      </span>
      <span className="font-body text-[11px] uppercase tracking-[0.15em] text-white/25">
        Top-of-Funnel Data & Distribution
      </span>
    </div>
  </footer>
);

export default Footer;
